const { REACT_APP_API_URL } = process.env;

const getProductTypes = async () => {
  const response = await fetch(`${REACT_APP_API_URL}prodigi/productTypes`);
  return response.json();
};

export default getProductTypes;
